import React, { useContext, useCallback, useRef } from 'react';
import { ThemeContext } from 'context/ThemeContext';
import Logo from './Logo';
import Breadcrumb from './Breadcrumb';
import HeaderNavigation from './HeaderNavigation';
import Search from './Search';
import OpenedViews from './OpenedViews';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box, IconButton } from '@mui/material';
import { toggleMenu, setSearchText, showMenu } from 'features/applicationState';
import { RootState } from 'types/types';
import { ReactComponent as OpenMenu } from 'assets/images/open-menu.svg';
import { ReactComponent as CloseMenu } from 'assets/images/close-menu.svg';
import { Ref as AIAssistantRef } from 'components/AIAssistant/AIAssistant';

interface Props {
  aiAssistantRef: React.RefObject<AIAssistantRef>;
}

const Header: React.FC<Props> = ({ aiAssistantRef }) => {
  const openedViewsRef = useRef<HTMLDivElement>(null);
  const { theme } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const { searchText, openedViews, toggle } = useSelector(
    (state: RootState) => state.applicationState
  );

  const headerStyle = {
    backgroundColor: theme,
  };

  const handleToggleMenu = () => {
    dispatch(toggleMenu());
  };

  const handleSearchChange = useCallback(
    (value: string) => {
      dispatch(showMenu());
      dispatch(setSearchText(value));
    },
    [dispatch]
  );

  return (
    <div className={`header ${theme}`} style={headerStyle}>
      <Box className={`header-inner`}>
        <Box>
          <Logo />
        </Box>
        <Box className={'center-header-elements'}>
          <IconButton
            className={`menu-icon menu-open-${toggle}`}
            onClick={handleToggleMenu}
          >
            {toggle ? <CloseMenu /> : <OpenMenu />}
          </IconButton>
          <Box>
            {openedViews.length > 0 && (
              <Grid container>
                <OpenedViews openedViewsRef={openedViewsRef} />
              </Grid>
            )}
            <Breadcrumb></Breadcrumb>
          </Box>
        </Box>
        <Box className={'right-header-elements'}>
          <Search
            handleSearchChange={handleSearchChange}
            searchText={searchText}
          ></Search>
          <HeaderNavigation aiAssistantRef={aiAssistantRef}></HeaderNavigation>
        </Box>
      </Box>
    </div>
  );
};

export default React.memo(Header);
